/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type JobTitle_job$ref = any;
export type JobStates = "ACCEPTED" | "ASSIGNED" | "BLOCKED" | "BLOCKED_FAILED" | "BROKEN" | "CANCELED" | "CANCELING" | "EXPIRED" | "FINISHED" | "LIMITED" | "LIMITING" | "PENDING" | "RUNNING" | "SCHEDULED" | "SKIPPED" | "TIMED_OUT" | "TIMING_OUT" | "UNBLOCKED" | "UNBLOCKED_FAILED" | "WAITING" | "WAITING_FAILED" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type AgentJobRow_job$ref: FragmentReference;
declare export opaque type AgentJobRow_job$fragmentType: AgentJobRow_job$ref;
export type AgentJobRow_job = {|
  +uuid: string,
  +state: JobStates,
  +passed: boolean,
  +scheduledAt: ?any,
  +startedAt: ?any,
  +url: string,
  +softFailed: boolean,
  +$fragmentRefs: JobTitle_job$ref,
  +$refType: AgentJobRow_job$ref,
|};
export type AgentJobRow_job$data = AgentJobRow_job;
export type AgentJobRow_job$key = {
  +$data?: AgentJobRow_job$data,
  +$fragmentRefs: AgentJobRow_job$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AgentJobRow_job",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "uuid",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "state",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "passed",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "scheduledAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "softFailed",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "JobTitle_job"
    }
  ],
  "type": "JobTypeCommand",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = 'b5ec618a1082f3560d33c970279fc426';

module.exports = node;
